/* ============================================================
 ScrollToTop
 Scrolls the window to the top whenever the route (pathname)
 changes, so navigating to a new page always lands at the top
 instead of preserving the previous scroll position.
 ============================================================ */
import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { trackPageView } from "@/lib/analytics";

export default function ScrollToTop() {
  const [location] = useLocation();
  // The GA4 base config tag in index.html already fires the first page_view on
  // load, so skip the initial mount and only send page_view on SPA navigations.
  const isFirst = useRef(true);

  useEffect(() => {
    // Jump instantly to top on route change. Use "auto" (instant)
    // rather than "smooth" so users never see a partial scroll.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    // Defer a tick so react-helmet-async has updated document.title first.
    const t = window.setTimeout(() => trackPageView(location), 0);
    return () => window.clearTimeout(t);
  }, [location]);

  return null;
}
